import { favoriteAgentTerms } from '../../../agent-production/constants/agentProductionConstants';

export const checkReservedName = (inputRef, setState, setStateData) => {
  const value = inputRef.current?.value?.trim().toLowerCase();

  if (value === favoriteAgentTerms.reservedListName.toLowerCase()) {
    setStateData('reservedNameWarning', favoriteAgentTerms.reservedListWarning, setState);
  }

  inputRef.current?.focus();
};
